/**
 * @file Logo
 * @author zhangyou
 */
import React from 'react'
import styled, { withTheme } from 'styled-components'
import { logoImgMap } from './images'

const Logo = styled.div`
  height: ${(props) => `${props.theme.headerHeight}px`};
  line-height: ${(props) => `${props.theme.headerHeight}px`};
  padding-left: 15px;
  width: 220px;
  background: #191d29;
  font-size: ${(props) => `${props.fontSize}px`};
  color: rgba(226, 237, 255, 0.9);
  letter-spacing: 0;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &:after {
    position: absolute;
    bottom: -12px;
    left: 0;
    background-image: linear-gradient(0deg, #191d29 23%, #151924 93%);
    content: '';
    width: 100%;
    height: 12px;
  }

  .ant-layout-sider-collapsed & {
    padding-left: 26px;
  }

  .compatible & {
    background: #213f83;
    color: #a1d7ff;
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.3);
    &:after {
      display: none;
    }
  }
  cursor: pointer;
  font-weight: 400;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .tnt-themeS1 & {
    background: #ffffff !important;
    box-shadow: 2px 3px 8px -1px rgba(0, 0, 0, 0.15);
    color: #17233d;
    &:after {
      display: none;
    }
  }

  .tnt-themeS1.compatible & {
    background: #323b4a;
  }

  // 蓝色主题
  .tnt-themeS3 & {
    background: ${(props) => `${props.theme.blueBgColor} !important`}; //#1D4295 !important;
    box-shadow: 2px 3px 8px -1px rgba(0, 0, 0, 0.15);
    color: #ffffff;
    &:after {
      display: none;
    }
  }

  img {
    position: relative;
    top: -1px;
    width: 23px;
    height: 23px;
    margin-right: 12px;
    .large-size & {
      width: 28px;
      height: 28px;
    }
  }
`

// JS判断字符串长度（英文占1个字符，中文汉字占2个字符）
const getStrLen = (str = '') => {
  let len = 0

  for (let i = 0; i < str.length; i++) {
    let c = str.charCodeAt(i)
    let chartLength = 2

    //单字节加1
    if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
      chartLength = 1
    }

    len += chartLength
  }

  return len
}

export default withTheme((props) => {
  const {
    logo,
    name,
    enName,
    language,
    collapsed,
    theme: { size },
  } = props
  const productNameLen = getStrLen(language === 'cn' ? name : enName)
  const fontSize =
    {
      12: 19,
      13: 18,
      14: 17,
      15: 16,
      16: 15,
    }[Math.max(12, Math.min(productNameLen, 16))] + (size === 'large' ? 1 : 0)
  const LogoImg = (props) => (
    <img
      onError={(e) => {
        e.target.onerror = null
        e.target.src = logoImgMap.default
      }}
      {...props}
    />
  )

  return (
    <Logo {...props} fontSize={fontSize}>
      {typeof logo === 'string' ? (
        <LogoImg src={logoImgMap[logo] || logoImgMap.default} />
      ) : logo && logo.type === 'img' ? (
        <LogoImg {...logo.props} src={logo.props?.src || logoImgMap.default} />
      ) : (
        logo
      )}
      {collapsed
        ? ''
        : {
            cn: name,
            en: enName,
          }[language]}
    </Logo>
  )
})
